import { IconImageM } from "@common/components/icons/IconsM"
import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"
import moment from "moment"
import React from "react"
import { View, StyleSheet } from "react-native"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"
import intensityLevel1 from "../../../../assets/icons/intensity-level/intensity_level_1.png"

import {
    materialLevelsColors,
    materialLevelsIcons,
} from "@common/chapters/ActivityLevelBadge"
import { calculateTimerColor } from "../../activity/execute/TimerContainer"

export const isActivityTooOld = (activity) =>
    !activity?.finished_at && moment().diff(activity?.created_at, "days") >= 7

export const TodoActivityBadges = (props) => {
    const { activity, style, custom = false, noDifficulty = false } = props

    return (
        <View style={{ flexDirection: "row", ...style }}>
            <View style={{...styles.wrapper, backgroundColor: custom ? null : theme.colors.whiteAlmost}}>
                <View
                    style={{
                        flexDirection: "row",
                        alignItems: "center",
                    }}
                >
                    <FontAwesome5
                        name={"stopwatch"}
                        solid
                        style={{ marginRight: 6 }}
                        color={
                            activity?.duration
                                ? calculateTimerColor(
                                      (activity?.duration * 100) /
                                          (props.activity?.estimated_duration * 60),
                                      "finished"
                                  )
                                : theme.colors.light
                        }
                        size={custom ? 10 : 14}
                    />
                    <TextM
                        fontWeight="SemiBold"
                        fontSize={custom ? 6 : 8}
                        wrap
                        color={theme.colors.light}
                    >
                        {activity?.duration && (
                            <TextM
                                fontSize={custom ? 10 : 12}
                                fontWeight="Bold"
                                color={calculateTimerColor(
                                    (activity?.duration * 100) /
                                        (props.activity?.estimated_duration * 60),
                                    "finished"
                                )}
                            >
                                {Math.floor(activity?.duration / 60)}
                            </TextM>
                        )}
                        {activity?.duration !== null ? " / " : "- / "}
                        {activity?.estimated_duration + " min"}
                    </TextM>
                    {!custom && !noDifficulty && (
                        <IconImageM
                            source={
                                materialLevelsIcons[activity?.level] ??
                                intensityLevel1
                            }
                            width={custom ? 12 : 18}
                            style={{
                                marginLeft: 6,
                                tintColor:
                                    materialLevelsColors[activity?.level] ??
                                    theme.colors.light,
                            }}
                        />
                    )}
                </View>
            </View>
        </View>
    )
}

const styles = StyleSheet.create({
    wrapper: {
        flexDirection: "row",
        alignItems: "center",
        borderRadius: 10,
        paddingHorizontal: 6,
        paddingVertical: 4,
    },
})
